<template>
  <div id="gzPage">
    <img class='bg' :src="img">
    <div class="btn" @click="goBack">
      <img src='../../assets/img/sy/dzp/back.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'sy_game_info',
    data () {
      return {
        img: {
          1: '//i2.letvimg.com/lc06_lemf/202001/07/16/46/dzphdgz.png'
        }[parseInt(this.$route.query.id || 1)]
      }
    },
    beforeCreate: function() {
      if (parseInt(this.$route.query.id) == 1 || !this.$route.query.id){
        document.title = '大转盘活动规则';
        document.getElementsByTagName("body")[0].setAttribute('style', 'background-color: #fe4a5f');
      }
    },
    beforeDestroy: function() {
      document.getElementsByTagName("body")[0].removeAttribute("style");
    },
    components: {},
    methods: {
      goBack(){
        this.$router.go(-1);
      }
    }
  }
</script>

<style>
  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  #gzPage {
    position: relative;
  }
  #gzPage .bg {
    vertical-align: top;
    width: 100%;
  }
  #gzPage .btn{
    position: absolute;
    height: 43px;
    top: 0;
  }
  #gzPage .btn img{
    height: 23px;
    margin-top: 20px;
    margin-left: 25px;
  }
</style>
